// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__10Vr0","log":"ModalInventoryLogs_log__2Iguu","date":"ModalInventoryLogs_date__1YipS","userName":"ModalInventoryLogs_userName__39UKc"};